var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect } from 'react';
import { useUnmount, useUpdateOnly } from '../../../custom-hooks';
import { useForm } from '../../useForm/useForm';
export const useFieldParent = ({ fieldId, isValid, isValidating, name, setTouch, value, }) => {
    _react_refresh_temp_1();
    const { forceValidateFlag, methods: { removeFromForm, setInForm }, } = useForm();
    useUnmount(() => {
        // No need to call setDirty, because a field could be
        // unmounted because removal form array, which calls
        // setDirty or from conditional field change, which
        // might have happened because some form state update
        // which calls setDirty:
        removeFromForm({ key: name });
    });
    // Update parent Form state:
    useEffect(() => {
        setInForm({
            isValid,
            isValidating,
            key: name,
            value,
        });
    }, [isValid, isValidating, name, value]);
    useUpdateOnly(() => {
        if (forceValidateFlag && Object.keys(forceValidateFlag).length === 0) {
            setTouch(true);
        }
        else if (forceValidateFlag &&
            typeof forceValidateFlag[fieldId] === 'boolean') {
            setTouch(forceValidateFlag[fieldId]);
        }
    }, [forceValidateFlag]);
};
_react_refresh_temp_1(useFieldParent, "pVy1M4Wf6JEa+ZX/rRIJAlzi2sg=", false, () => [useForm, useUnmount, useUpdateOnly]);
